export default __webpack_public_path__ + "static/media/guide01.52e7adcc.png";